import { doNothing } from "@edgetier/utilities";
import hotkeys from "hotkeys-js";
import { useEffect } from "react";

/**
 * Create a keyboard shortcuts for navigating to the previous/next phrase sample with the up/down arrow keys.
 * @param items          The phrase samples in the preview results table.
 * @param setVisibleItem    The currently visible phrase sample.
 * @param setVisibleItem Function to set what phrase sample is visible in the modal.
 */
export const useModalKeyboardShortcut = <T = any[]>(
    items: T[],
    visibleItem: T,
    setVisibleItem: (item: T) => void,
    loadMoreItems?: VoidFunction
) => {
    useEffect(() => {
        const setVisibleItemIndex = items.indexOf(visibleItem);
        const previousItemIndex = setVisibleItemIndex - 1;
        const upCallback = previousItemIndex < 0 ? doNothing : () => setVisibleItem(items[previousItemIndex]);

        const maxIndex = items.length - 1;
        const nextItemIndex = setVisibleItemIndex + 1;
        const downCallback =
            nextItemIndex > maxIndex
                ? typeof loadMoreItems === "function"
                    ? loadMoreItems
                    : doNothing
                : () => setVisibleItem(items[nextItemIndex]);

        hotkeys("up", upCallback);
        hotkeys("down", downCallback);

        // Unbind the shortcuts on cleanup or else several callbacks will run when the shortcut is triggered.
        return () => {
            hotkeys.unbind("up", upCallback);
            hotkeys.unbind("down", downCallback);
        };
    }, [items, visibleItem, setVisibleItem, loadMoreItems]);
};
